
import { EVENT_UNLOAD, EVENT_LOADED, eventsActions } from './events.era';
import { Action, createActionGroup, createFeature, createFeatureSelector, createReducer, on } from '@ngrx/store'
import { createEntityAdapter, Dictionary, EntityState } from '@ngrx/entity';
import { Asset } from 'globals/store/assets.data';
import { Ranking } from 'globals/store/events.data';
import { makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers';
import { userActions } from './user.era';

export const ADD_ASSETS = '[Assets] Add'
export const DELETE_ASSETS = '[Assets] Delete'

export interface AssetsState extends EntityState<Asset> {
  assetCategories: { [id:string]: Ranking }
}

const getDefaultExhibitorsState = (): AssetsState => ({
  ids: [],
  entities: {},
  assetCategories: {}
})

export const adapter = createEntityAdapter<Asset>()
export const makeInitialState = (): AssetsState => adapter.getInitialState(getDefaultExhibitorsState())

export const assetsActions = createActionGroup({
  source: 'Assets',
  events: {
    'Add Assets': (assets: Asset[]) => ({ assets }),
    'Delete Assets': (ids: string[]) => ({ ids }),
  }
})
export const assetsReducer = createReducer(
  makeInitialState(),
  on(assetsActions.addAssets, (state, { assets }) => adapter.upsertMany(assets, state)),
  on(assetsActions.deleteAssets, (state, { ids }) => adapter.removeMany(ids, state)),
  on(eventsActions.loadEvent, (state, { payload }) => {
    const changedState = adapter.addMany(Object.values(payload.assets), state)
    const newState = { ...changedState }
    newState.assetCategories = !payload.assetCategories ? {} : makeMapFromListOfObjectsAndKey(payload.assetCategories, 'id')
    return newState
  }),
  on(eventsActions.unloadEvent, (state) => makeInitialState()),
  on(userActions.logout, (state) => makeInitialState()),
)

export const assetsFeature = createFeature({
  name: 'assets',
  reducer: assetsReducer
})

export const assetsStateSelector = createFeatureSelector<AssetsState>(assetsFeature.name)


